import React from "react";

interface Props {
  title: string;
}

const SidebarHeader: React.FC<Props> = ({ title }) => {
  
  return (
    <div className="tour-sidebar-header">
      <div className='tour-sidebar-header-title'>{title}</div>
    </div>
  );
};

export default SidebarHeader;